import { Injectable } from '@angular/core';
import { catchError, from, map, Observable, switchMap } from 'rxjs';
import { GetObjectCommand, S3Client } from '@aws-sdk/client-s3';
import { fromCognitoIdentityPool } from '@aws-sdk/credential-provider-cognito-identity';
import { environment } from '../../../environments/environment';
import { S3ExportType } from '../enums/S3ExportType.enum';

@Injectable({
  providedIn: 'root',
})
export class HowtoService {
  private s3: S3Client;

  constructor() {
    this.s3 = new S3Client({
      region: environment.s3Region1,
      credentials: fromCognitoIdentityPool({
        clientConfig: { region: environment.s3Region1 },
        identityPoolId: environment.cognitoId,
      }),
    });
  }

  public getObject(fileName: string, type: S3ExportType): Observable<Blob> {
    const params = { Bucket: environment.S3buckets.howTo, Key: fileName };

    return from(this.s3.send(new GetObjectCommand(params))).pipe(
      switchMap(response => {
        if (!response.Body) {
          throw new Error();
        }
        return from(response.Body.transformToByteArray());
      }),
      map(byteArray => new Blob([new Uint8Array(byteArray)], { type })),
      catchError((error: string) => {
        throw new Error(error);
      }),
    );
  }

  public downloadFile(fileName: string, blob: Blob): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
}
